// <auto-generated>
// Generated from SpeciesSettings.cs.
// Do not edit manually.
// </auto-generated>

import { signal } from "@preact/signals";

const DegToRad = Math.PI / 180.0;
const RadToDeg = 180.0 / Math.PI;

export class SpeciesBase {
    contactDeformationMode = signal(0);
    contactLeafFoldingEnabled = signal(true);
    petioleContactBendDegrees = signal(0);
    name = signal("Default");
    aka = signal("");
    behaviorIndex = signal(0);
    height = signal(10);
    nodeDistance = signal(0.04);
    nodeDistanceVar = signal(0.01);
    monopodialFactor = signal(1);
    dominanceFactor = signal(0.7);
    lateralsPerNode = signal(2);
    lateralPitchDeg = signal(45);
    lateralPitchDegVar = signal(5);
    lateralRollDeg = signal(0);
    lateralRollDegVar = signal(5);
    twigsBending = signal(0.5);
    twigsBendingByLevel = signal(1);
    twigsBendingApical = signal(0.02);
    shootsGravitaxis = signal(0.2);
    shootsGravitropicSetPointAngleDeg = signal(0);
    shootsGravitropicRatePerHour = signal(0);
    woodGrowthTime = signal(100);
    woodGrowthTimeVar = signal(10);
    leafLength = signal(0.12);
    leafLengthVar = signal(0.02);
    leafSegmentLength = signal(0);
    leafKeelThickness = signal(0.0028);
    leafElasticModulus = signal(0);
    leafMembraneElasticModulus = signal(0);
    leafBendingElasticModulus = signal(0);
    leafMechanicalThickness = signal(0);
    leafPoissonRatio = signal(0.3);
    leafTipStiffnessFraction = signal(1);
    maximumLeafSegments = signal(16);
    leafRadius = signal(0.04);
    leafRadiusVar = signal(0.01);
    leafPitchDeg = signal(20);
    leafPitchDegVar = signal(5);
    petioleLength = signal(0.04);
    petioleLengthVar = signal(0.01);
    petioleRadius = signal(0.0025);
    petioleRadiusVar = signal(0.0005);
    leafGrowthTime = signal(480);
    leafExpansionRateScale = signal(1);
    constructionEnergyPerDryGram = signal(0);
    leafGrowthTimeVar = signal(120);
    leafSenescenceSeasonalDuration = signal(480);
    leafSenescenceSeasonalDurationVar = signal(120);
    leafSenescenceStressDuration = signal(140);
    leafSenescenceStressDurationVar = signal(60);
    seasonalSenescence = signal(0.7090909091);
    rootsDensity = signal(0.5);
    rootsGravitaxis = signal(0.2);
    densityDryWood = signal(700000);
    densityDryStem = signal(200000);
    auxinsProduction = signal(40);
    cytokininsProduction = signal(40);
    auxinsReach = signal(1);
    cytokininsReach = signal(1);
    auxinsThreshold = signal(1);
    floweringStartAgeHours = signal(1080);
    floweringSeasonStart = signal(0.1818181818);
    floweringSeasonEnd = signal(0.4545454545);
    floweringPhaseDurationHours = signal(720);
    preFloweringCommitmentProbabilityPerHour = signal(0.0005);
    floweringCommitmentProbabilityPerHour = signal(0.045);
    postFloweringCommitmentProbabilityPerHour = signal(0.001);
    dormantFloweringCommitmentProbabilityPerHour = signal(0);
    preFloweringCrownContinuationProbabilityPerHour = signal(0);
    floweringCrownContinuationProbabilityPerHour = signal(0.0001);
    postFloweringCrownContinuationProbabilityPerHour = signal(0.001);
    dormantCrownContinuationProbabilityPerHour = signal(0);
    continueCrownAfterFlowerCommitment = signal(true);
    basalScapeEmergenceMaxTiltDegrees = signal(0);
    flowerStemSegmentGrowthDurationVarianceHours = signal(0);
    budBloomDurationVarianceHours = signal(0);
    maximumFlowersPerCrown = signal(1);
    woodElasticModulus = signal(100000000);
    greenElasticModulus = signal(100000000);
    basalGreenElasticModulus = signal(200000000);
    basalStiffnessAttenuationPerSegment = signal(0.01);
    petioleElasticModulus = signal(200000000);
    flowerOrganElasticModulus = signal(5000000);
    flowerPedicelElasticModulus = signal(40000000);
    flowerScapeElasticModulus = signal(0);
    leafMaximumAgeHours = signal(17520);
    crownBudActivationPeriod = signal(1);
    crownBudActivationProbabilityPerSeason = signal(1);
    crownBudBreakWindowHours = signal(720);
    crownBudRadius = signal(0.0005);
    crownNodeHeightAboveSoil = signal(0.005);
    minimumInternodeLength = signal(0.001);
    crownPitchDeg = signal(90);
    crownMaximumNodes = signal(0);
    herbaceousGrowthRateScale = signal(0.2);
    shootMaximumRadius = signal(0.0005);
    petioleReorientationMaximumAngleDeg = signal(54);
    petioleReorientationStepAngleDeg = signal(0);
    petioleSegmentLength = signal(0);
    maximumPetioleSegments = signal(8);
    rhizomeGrowthRateScale = signal(0.05);
    rhizomeBudActivationPeriod = signal(7);
    rhizomeBasalBudActivationProbabilityPerHour = signal(0.005);
    rhizomeAxillaryBudActivationProbabilityPerHour = signal(0);
    rhizomeAxillaryBudActivationProbabilityPerSeason = signal(0);
    rhizomeBudBreakWindowHours = signal(720);
    rhizomeObstacleDeflectionAngleDeg = signal(50);
    rhizomeAxillaryBudsPerSegment = signal(0);
    initialBasalRhizomeBuds = signal(3);
    rhizomeMaximumSegmentDepth = signal(15);
    rhizomeSegmentLength = signal(0.025);
    rhizomeSegmentLengthVar = signal(0.02);
    rhizomeSegmentRadius = signal(0.0025);
    rhizomeBudRadius = signal(0.0005);
    retainDormantRhizomes = signal(false);
    droughtSenescenceOnset = signal(0.3);
    canopyAdjustmentHalfTimeDays = signal(7);
    deadLeafAttachmentHours = signal(336);

    public save() {
        return {
            contactDeformationMode: this.contactDeformationMode.peek(),
            contactLeafFoldingEnabled: this.contactLeafFoldingEnabled.peek(),
            petioleContactBendDegrees: this.petioleContactBendDegrees.peek(),
            name: this.name.peek(),
            aka: this.aka.peek(),
            behavior: this.behaviorIndex.peek(),
            height: this.height.peek(),
            nodeDistance: this.nodeDistance.peek(),
            nodeDistanceVar: this.nodeDistanceVar.peek(),
            monopodialFactor: this.monopodialFactor.peek(),
            dominanceFactor: this.dominanceFactor.peek(),
            lateralsPerNode: this.lateralsPerNode.peek(),
            lateralPitch: this.lateralPitchDeg.peek() * DegToRad,
            lateralPitchVar: this.lateralPitchDegVar.peek() * DegToRad,
            lateralRoll: this.lateralRollDeg.peek() * DegToRad,
            lateralRollVar: this.lateralRollDegVar.peek() * DegToRad,
            twigsBending: this.twigsBending.peek(),
            twigsBendingByLevel: this.twigsBendingByLevel.peek(),
            twigsBendingApical: this.twigsBendingApical.peek(),
            shootsGravitaxis: this.shootsGravitaxis.peek(),
            shootsGravitropicSetPointAngle: this.shootsGravitropicSetPointAngleDeg.peek() * DegToRad,
            shootsGravitropicRatePerHour: this.shootsGravitropicRatePerHour.peek(),
            woodGrowthTime: this.woodGrowthTime.peek(),
            woodGrowthTimeVar: this.woodGrowthTimeVar.peek(),
            leafLength: this.leafLength.peek(),
            leafLengthVar: this.leafLengthVar.peek(),
            leafSegmentLength: this.leafSegmentLength.peek(),
            leafKeelThickness: this.leafKeelThickness.peek(),
            leafElasticModulus: this.leafElasticModulus.peek(),
            leafMembraneElasticModulus: this.leafMembraneElasticModulus.peek(),
            leafBendingElasticModulus: this.leafBendingElasticModulus.peek(),
            leafMechanicalThickness: this.leafMechanicalThickness.peek(),
            leafPoissonRatio: this.leafPoissonRatio.peek(),
            leafTipStiffnessFraction: this.leafTipStiffnessFraction.peek(),
            maximumLeafSegments: this.maximumLeafSegments.peek(),
            leafRadius: this.leafRadius.peek(),
            leafRadiusVar: this.leafRadiusVar.peek(),
            leafPitch: this.leafPitchDeg.peek() * DegToRad,
            leafPitchVar: this.leafPitchDegVar.peek() * DegToRad,
            petioleLength: this.petioleLength.peek(),
            petioleLengthVar: this.petioleLengthVar.peek(),
            petioleRadius: this.petioleRadius.peek(),
            petioleRadiusVar: this.petioleRadiusVar.peek(),
            leafGrowthTime: this.leafGrowthTime.peek(),
            leafExpansionRateScale: this.leafExpansionRateScale.peek(),
            constructionEnergyPerDryGram: this.constructionEnergyPerDryGram.peek(),
            leafGrowthTimeVar: this.leafGrowthTimeVar.peek(),
            leafSenescenceSeasonalDuration: this.leafSenescenceSeasonalDuration.peek(),
            leafSenescenceSeasonalDurationVar: this.leafSenescenceSeasonalDurationVar.peek(),
            leafSenescenceStressDuration: this.leafSenescenceStressDuration.peek(),
            leafSenescenceStressDurationVar: this.leafSenescenceStressDurationVar.peek(),
            seasonalSenescence: this.seasonalSenescence.peek(),
            rootsDensity: this.rootsDensity.peek(),
            rootsGravitaxis: this.rootsGravitaxis.peek(),
            densityDryWood: this.densityDryWood.peek(),
            densityDryStem: this.densityDryStem.peek(),
            auxinsProduction: this.auxinsProduction.peek(),
            cytokininsProduction: this.cytokininsProduction.peek(),
            auxinsReach: this.auxinsReach.peek(),
            cytokininsReach: this.cytokininsReach.peek(),
            auxinsThreshold: this.auxinsThreshold.peek(),
            floweringStartAgeHours: this.floweringStartAgeHours.peek(),
            floweringSeasonStart: this.floweringSeasonStart.peek(),
            floweringSeasonEnd: this.floweringSeasonEnd.peek(),
            floweringPhaseDurationHours: this.floweringPhaseDurationHours.peek(),
            preFloweringCommitmentProbabilityPerHour: this.preFloweringCommitmentProbabilityPerHour.peek(),
            floweringCommitmentProbabilityPerHour: this.floweringCommitmentProbabilityPerHour.peek(),
            postFloweringCommitmentProbabilityPerHour: this.postFloweringCommitmentProbabilityPerHour.peek(),
            dormantFloweringCommitmentProbabilityPerHour: this.dormantFloweringCommitmentProbabilityPerHour.peek(),
            preFloweringCrownContinuationProbabilityPerHour: this.preFloweringCrownContinuationProbabilityPerHour.peek(),
            floweringCrownContinuationProbabilityPerHour: this.floweringCrownContinuationProbabilityPerHour.peek(),
            postFloweringCrownContinuationProbabilityPerHour: this.postFloweringCrownContinuationProbabilityPerHour.peek(),
            dormantCrownContinuationProbabilityPerHour: this.dormantCrownContinuationProbabilityPerHour.peek(),
            continueCrownAfterFlowerCommitment: this.continueCrownAfterFlowerCommitment.peek(),
            basalScapeEmergenceMaxTiltDegrees: this.basalScapeEmergenceMaxTiltDegrees.peek(),
            flowerStemSegmentGrowthDurationVarianceHours: this.flowerStemSegmentGrowthDurationVarianceHours.peek(),
            budBloomDurationVarianceHours: this.budBloomDurationVarianceHours.peek(),
            maximumFlowersPerCrown: this.maximumFlowersPerCrown.peek(),
            woodElasticModulus: this.woodElasticModulus.peek(),
            greenElasticModulus: this.greenElasticModulus.peek(),
            basalGreenElasticModulus: this.basalGreenElasticModulus.peek(),
            basalStiffnessAttenuationPerSegment: this.basalStiffnessAttenuationPerSegment.peek(),
            petioleElasticModulus: this.petioleElasticModulus.peek(),
            flowerOrganElasticModulus: this.flowerOrganElasticModulus.peek(),
            flowerPedicelElasticModulus: this.flowerPedicelElasticModulus.peek(),
            flowerScapeElasticModulus: this.flowerScapeElasticModulus.peek(),
            leafMaximumAgeHours: this.leafMaximumAgeHours.peek(),
            crownBudActivationPeriod: this.crownBudActivationPeriod.peek(),
            crownBudActivationProbabilityPerSeason: this.crownBudActivationProbabilityPerSeason.peek(),
            crownBudBreakWindowHours: this.crownBudBreakWindowHours.peek(),
            crownBudRadius: this.crownBudRadius.peek(),
            crownNodeHeightAboveSoil: this.crownNodeHeightAboveSoil.peek(),
            minimumInternodeLength: this.minimumInternodeLength.peek(),
            crownPitch: this.crownPitchDeg.peek() * DegToRad,
            crownMaximumNodes: this.crownMaximumNodes.peek(),
            herbaceousGrowthRateScale: this.herbaceousGrowthRateScale.peek(),
            shootMaximumRadius: this.shootMaximumRadius.peek(),
            petioleReorientationMaximumAngle: this.petioleReorientationMaximumAngleDeg.peek() * DegToRad,
            petioleReorientationStepAngle: this.petioleReorientationStepAngleDeg.peek() * DegToRad,
            petioleSegmentLength: this.petioleSegmentLength.peek(),
            maximumPetioleSegments: this.maximumPetioleSegments.peek(),
            rhizomeGrowthRateScale: this.rhizomeGrowthRateScale.peek(),
            rhizomeBudActivationPeriod: this.rhizomeBudActivationPeriod.peek(),
            rhizomeBasalBudActivationProbabilityPerHour: this.rhizomeBasalBudActivationProbabilityPerHour.peek(),
            rhizomeAxillaryBudActivationProbabilityPerHour: this.rhizomeAxillaryBudActivationProbabilityPerHour.peek(),
            rhizomeAxillaryBudActivationProbabilityPerSeason: this.rhizomeAxillaryBudActivationProbabilityPerSeason.peek(),
            rhizomeBudBreakWindowHours: this.rhizomeBudBreakWindowHours.peek(),
            rhizomeObstacleDeflectionAngle: this.rhizomeObstacleDeflectionAngleDeg.peek() * DegToRad,
            rhizomeAxillaryBudsPerSegment: this.rhizomeAxillaryBudsPerSegment.peek(),
            initialBasalRhizomeBuds: this.initialBasalRhizomeBuds.peek(),
            rhizomeMaximumSegmentDepth: this.rhizomeMaximumSegmentDepth.peek(),
            rhizomeSegmentLength: this.rhizomeSegmentLength.peek(),
            rhizomeSegmentLengthVar: this.rhizomeSegmentLengthVar.peek(),
            rhizomeSegmentRadius: this.rhizomeSegmentRadius.peek(),
            rhizomeBudRadius: this.rhizomeBudRadius.peek(),
            retainDormantRhizomes: this.retainDormantRhizomes.peek(),
            droughtSenescenceOnset: this.droughtSenescenceOnset.peek(),
            canopyAdjustmentHalfTimeDays: this.canopyAdjustmentHalfTimeDays.peek(),
            deadLeafAttachmentHours: this.deadLeafAttachmentHours.peek(),
        };
    }

    public load(s: any) {
        this.contactDeformationMode.value = s.contactDeformationMode ?? 0;
        this.contactLeafFoldingEnabled.value = s.contactLeafFoldingEnabled;
        this.petioleContactBendDegrees.value = s.petioleContactBendDegrees;
        this.name.value = s.name;
        this.aka.value = s.aka;
        this.behaviorIndex.value = s.behavior;
        this.height.value = s.height;
        this.nodeDistance.value = s.nodeDistance;
        this.nodeDistanceVar.value = s.nodeDistanceVar;
        this.monopodialFactor.value = s.monopodialFactor;
        this.dominanceFactor.value = s.dominanceFactor;
        this.lateralsPerNode.value = s.lateralsPerNode;
        this.lateralPitchDeg.value = s.lateralPitch * RadToDeg;
        this.lateralPitchDegVar.value = s.lateralPitchVar * RadToDeg;
        this.lateralRollDeg.value = s.lateralRoll * RadToDeg;
        this.lateralRollDegVar.value = s.lateralRollVar * RadToDeg;
        this.twigsBending.value = s.twigsBending;
        this.twigsBendingByLevel.value = s.twigsBendingByLevel;
        this.twigsBendingApical.value = s.twigsBendingApical;
        this.shootsGravitaxis.value = s.shootsGravitaxis;
        this.shootsGravitropicSetPointAngleDeg.value = s.shootsGravitropicSetPointAngle * RadToDeg;
        this.shootsGravitropicRatePerHour.value = s.shootsGravitropicRatePerHour;
        this.woodGrowthTime.value = s.woodGrowthTime;
        this.woodGrowthTimeVar.value = s.woodGrowthTimeVar;
        this.leafLength.value = s.leafLength;
        this.leafLengthVar.value = s.leafLengthVar;
        this.leafSegmentLength.value = s.leafSegmentLength;
        this.leafKeelThickness.value = s.leafKeelThickness;
        this.leafElasticModulus.value = s.leafElasticModulus;
        this.leafMembraneElasticModulus.value = s.leafMembraneElasticModulus ?? 0;
        this.leafBendingElasticModulus.value = s.leafBendingElasticModulus ?? 0;
        this.leafMechanicalThickness.value = s.leafMechanicalThickness ?? 0;
        this.leafPoissonRatio.value = s.leafPoissonRatio ?? 0.3;
        this.leafTipStiffnessFraction.value = s.leafTipStiffnessFraction;
        this.maximumLeafSegments.value = s.maximumLeafSegments;
        this.leafRadius.value = s.leafRadius;
        this.leafRadiusVar.value = s.leafRadiusVar;
        this.leafPitchDeg.value = s.leafPitch * RadToDeg;
        this.leafPitchDegVar.value = s.leafPitchVar * RadToDeg;
        this.petioleLength.value = s.petioleLength;
        this.petioleLengthVar.value = s.petioleLengthVar;
        this.petioleRadius.value = s.petioleRadius;
        this.petioleRadiusVar.value = s.petioleRadiusVar;
        this.leafGrowthTime.value = s.leafGrowthTime;
        this.leafExpansionRateScale.value = s.leafExpansionRateScale;
        this.constructionEnergyPerDryGram.value = s.constructionEnergyPerDryGram;
        this.leafGrowthTimeVar.value = s.leafGrowthTimeVar;
        this.leafSenescenceSeasonalDuration.value = s.leafSenescenceSeasonalDuration;
        this.leafSenescenceSeasonalDurationVar.value = s.leafSenescenceSeasonalDurationVar;
        this.leafSenescenceStressDuration.value = s.leafSenescenceStressDuration;
        this.leafSenescenceStressDurationVar.value = s.leafSenescenceStressDurationVar;
        this.seasonalSenescence.value = s.seasonalSenescence;
        this.rootsDensity.value = s.rootsDensity;
        this.rootsGravitaxis.value = s.rootsGravitaxis;
        this.densityDryWood.value = s.densityDryWood;
        this.densityDryStem.value = s.densityDryStem;
        this.auxinsProduction.value = s.auxinsProduction;
        this.cytokininsProduction.value = s.cytokininsProduction;
        this.auxinsReach.value = s.auxinsReach;
        this.cytokininsReach.value = s.cytokininsReach;
        this.auxinsThreshold.value = s.auxinsThreshold;
        this.floweringStartAgeHours.value = s.floweringStartAgeHours;
        this.floweringSeasonStart.value = s.floweringSeasonStart;
        this.floweringSeasonEnd.value = s.floweringSeasonEnd;
        this.floweringPhaseDurationHours.value = s.floweringPhaseDurationHours;
        this.preFloweringCommitmentProbabilityPerHour.value = s.preFloweringCommitmentProbabilityPerHour;
        this.floweringCommitmentProbabilityPerHour.value = s.floweringCommitmentProbabilityPerHour;
        this.postFloweringCommitmentProbabilityPerHour.value = s.postFloweringCommitmentProbabilityPerHour;
        this.dormantFloweringCommitmentProbabilityPerHour.value = s.dormantFloweringCommitmentProbabilityPerHour;
        this.preFloweringCrownContinuationProbabilityPerHour.value = s.preFloweringCrownContinuationProbabilityPerHour;
        this.floweringCrownContinuationProbabilityPerHour.value = s.floweringCrownContinuationProbabilityPerHour;
        this.postFloweringCrownContinuationProbabilityPerHour.value = s.postFloweringCrownContinuationProbabilityPerHour;
        this.dormantCrownContinuationProbabilityPerHour.value = s.dormantCrownContinuationProbabilityPerHour;
        this.continueCrownAfterFlowerCommitment.value = s.continueCrownAfterFlowerCommitment;
        this.basalScapeEmergenceMaxTiltDegrees.value = s.basalScapeEmergenceMaxTiltDegrees;
        this.flowerStemSegmentGrowthDurationVarianceHours.value = s.flowerStemSegmentGrowthDurationVarianceHours;
        this.budBloomDurationVarianceHours.value = s.budBloomDurationVarianceHours;
        this.maximumFlowersPerCrown.value = s.maximumFlowersPerCrown;
        this.woodElasticModulus.value = s.woodElasticModulus;
        this.greenElasticModulus.value = s.greenElasticModulus;
        this.basalGreenElasticModulus.value = s.basalGreenElasticModulus;
        this.basalStiffnessAttenuationPerSegment.value = s.basalStiffnessAttenuationPerSegment;
        this.petioleElasticModulus.value = s.petioleElasticModulus;
        this.flowerOrganElasticModulus.value = s.flowerOrganElasticModulus;
        this.flowerPedicelElasticModulus.value = s.flowerPedicelElasticModulus;
        this.flowerScapeElasticModulus.value = s.flowerScapeElasticModulus;
        this.leafMaximumAgeHours.value = s.leafMaximumAgeHours;
        this.crownBudActivationPeriod.value = s.crownBudActivationPeriod;
        this.crownBudActivationProbabilityPerSeason.value = s.crownBudActivationProbabilityPerSeason;
        this.crownBudBreakWindowHours.value = s.crownBudBreakWindowHours;
        this.crownBudRadius.value = s.crownBudRadius;
        this.crownNodeHeightAboveSoil.value = s.crownNodeHeightAboveSoil;
        this.minimumInternodeLength.value = s.minimumInternodeLength;
        this.crownPitchDeg.value = s.crownPitch * RadToDeg;
        this.crownMaximumNodes.value = s.crownMaximumNodes;
        this.herbaceousGrowthRateScale.value = s.herbaceousGrowthRateScale;
        this.shootMaximumRadius.value = s.shootMaximumRadius;
        this.petioleReorientationMaximumAngleDeg.value = s.petioleReorientationMaximumAngle * RadToDeg;
        this.petioleReorientationStepAngleDeg.value = s.petioleReorientationStepAngle * RadToDeg;
        this.petioleSegmentLength.value = s.petioleSegmentLength;
        this.maximumPetioleSegments.value = s.maximumPetioleSegments;
        this.rhizomeGrowthRateScale.value = s.rhizomeGrowthRateScale;
        this.rhizomeBudActivationPeriod.value = s.rhizomeBudActivationPeriod;
        this.rhizomeBasalBudActivationProbabilityPerHour.value = s.rhizomeBasalBudActivationProbabilityPerHour;
        this.rhizomeAxillaryBudActivationProbabilityPerHour.value = s.rhizomeAxillaryBudActivationProbabilityPerHour;
        this.rhizomeAxillaryBudActivationProbabilityPerSeason.value = s.rhizomeAxillaryBudActivationProbabilityPerSeason;
        this.rhizomeBudBreakWindowHours.value = s.rhizomeBudBreakWindowHours;
        this.rhizomeObstacleDeflectionAngleDeg.value = s.rhizomeObstacleDeflectionAngle * RadToDeg;
        this.rhizomeAxillaryBudsPerSegment.value = s.rhizomeAxillaryBudsPerSegment;
        this.initialBasalRhizomeBuds.value = s.initialBasalRhizomeBuds;
        this.rhizomeMaximumSegmentDepth.value = s.rhizomeMaximumSegmentDepth;
        this.rhizomeSegmentLength.value = s.rhizomeSegmentLength;
        this.rhizomeSegmentLengthVar.value = s.rhizomeSegmentLengthVar;
        this.rhizomeSegmentRadius.value = s.rhizomeSegmentRadius;
        this.rhizomeBudRadius.value = s.rhizomeBudRadius;
        this.retainDormantRhizomes.value = s.retainDormantRhizomes;
        this.droughtSenescenceOnset.value = s.droughtSenescenceOnset ?? 0.3;
        this.canopyAdjustmentHalfTimeDays.value = s.canopyAdjustmentHalfTimeDays ?? 7;
        this.deadLeafAttachmentHours.value = s.deadLeafAttachmentHours ?? 336;
        return this;
    }

    public serialize() {
        return {
            ContactDeformationMode: this.contactDeformationMode.peek(),
            ContactLeafFoldingEnabled: this.contactLeafFoldingEnabled.peek(),
            PetioleContactBendDegrees: this.petioleContactBendDegrees.peek(),
            Name: this.name.peek(),
            Aka: this.aka.peek(),
            Behavior: this.behaviorIndex.peek(),
            Height: this.height.peek(),
            NodeDistance: this.nodeDistance.peek(),
            NodeDistanceVar: this.nodeDistanceVar.peek(),
            MonopodialFactor: this.monopodialFactor.peek(),
            DominanceFactor: this.dominanceFactor.peek(),
            LateralsPerNode: this.lateralsPerNode.peek(),
            LateralPitch: this.lateralPitchDeg.peek() * DegToRad,
            LateralPitchVar: this.lateralPitchDegVar.peek() * DegToRad,
            LateralRoll: this.lateralRollDeg.peek() * DegToRad,
            LateralRollVar: this.lateralRollDegVar.peek() * DegToRad,
            TwigsBending: this.twigsBending.peek(),
            TwigsBendingByLevel: this.twigsBendingByLevel.peek(),
            TwigsBendingApical: this.twigsBendingApical.peek(),
            ShootsGravitaxis: this.shootsGravitaxis.peek(),
            ShootsGravitropicSetPointAngle: this.shootsGravitropicSetPointAngleDeg.peek() * DegToRad,
            ShootsGravitropicRatePerHour: this.shootsGravitropicRatePerHour.peek(),
            WoodGrowthTime: this.woodGrowthTime.peek(),
            WoodGrowthTimeVar: this.woodGrowthTimeVar.peek(),
            LeafLength: this.leafLength.peek(),
            LeafLengthVar: this.leafLengthVar.peek(),
            LeafSegmentLength: this.leafSegmentLength.peek(),
            LeafKeelThickness: this.leafKeelThickness.peek(),
            LeafElasticModulus: this.leafElasticModulus.peek(),
            LeafMembraneElasticModulus: this.leafMembraneElasticModulus.peek(),
            LeafBendingElasticModulus: this.leafBendingElasticModulus.peek(),
            LeafMechanicalThickness: this.leafMechanicalThickness.peek(),
            LeafPoissonRatio: this.leafPoissonRatio.peek(),
            LeafTipStiffnessFraction: this.leafTipStiffnessFraction.peek(),
            MaximumLeafSegments: this.maximumLeafSegments.peek(),
            LeafRadius: this.leafRadius.peek(),
            LeafRadiusVar: this.leafRadiusVar.peek(),
            LeafPitch: this.leafPitchDeg.peek() * DegToRad,
            LeafPitchVar: this.leafPitchDegVar.peek() * DegToRad,
            PetioleLength: this.petioleLength.peek(),
            PetioleLengthVar: this.petioleLengthVar.peek(),
            PetioleRadius: this.petioleRadius.peek(),
            PetioleRadiusVar: this.petioleRadiusVar.peek(),
            LeafGrowthTime: this.leafGrowthTime.peek(),
            LeafExpansionRateScale: this.leafExpansionRateScale.peek(),
            ConstructionEnergyPerDryGram: this.constructionEnergyPerDryGram.peek(),
            LeafGrowthTimeVar: this.leafGrowthTimeVar.peek(),
            LeafSenescenceSeasonalDuration: this.leafSenescenceSeasonalDuration.peek(),
            LeafSenescenceSeasonalDurationVar: this.leafSenescenceSeasonalDurationVar.peek(),
            LeafSenescenceStressDuration: this.leafSenescenceStressDuration.peek(),
            LeafSenescenceStressDurationVar: this.leafSenescenceStressDurationVar.peek(),
            SeasonalSenescence: this.seasonalSenescence.peek(),
            RootsDensity: this.rootsDensity.peek(),
            RootsGravitaxis: this.rootsGravitaxis.peek(),
            DensityDryWood: this.densityDryWood.peek(),
            DensityDryStem: this.densityDryStem.peek(),
            AuxinsProduction: this.auxinsProduction.peek(),
            CytokininsProduction: this.cytokininsProduction.peek(),
            AuxinsReach: this.auxinsReach.peek(),
            CytokininsReach: this.cytokininsReach.peek(),
            AuxinsThreshold: this.auxinsThreshold.peek(),
            FloweringStartAgeHours: this.floweringStartAgeHours.peek(),
            FloweringSeasonStart: this.floweringSeasonStart.peek(),
            FloweringSeasonEnd: this.floweringSeasonEnd.peek(),
            FloweringPhaseDurationHours: this.floweringPhaseDurationHours.peek(),
            PreFloweringCommitmentProbabilityPerHour: this.preFloweringCommitmentProbabilityPerHour.peek(),
            FloweringCommitmentProbabilityPerHour: this.floweringCommitmentProbabilityPerHour.peek(),
            PostFloweringCommitmentProbabilityPerHour: this.postFloweringCommitmentProbabilityPerHour.peek(),
            DormantFloweringCommitmentProbabilityPerHour: this.dormantFloweringCommitmentProbabilityPerHour.peek(),
            PreFloweringCrownContinuationProbabilityPerHour: this.preFloweringCrownContinuationProbabilityPerHour.peek(),
            FloweringCrownContinuationProbabilityPerHour: this.floweringCrownContinuationProbabilityPerHour.peek(),
            PostFloweringCrownContinuationProbabilityPerHour: this.postFloweringCrownContinuationProbabilityPerHour.peek(),
            DormantCrownContinuationProbabilityPerHour: this.dormantCrownContinuationProbabilityPerHour.peek(),
            ContinueCrownAfterFlowerCommitment: this.continueCrownAfterFlowerCommitment.peek(),
            BasalScapeEmergenceMaxTiltDegrees: this.basalScapeEmergenceMaxTiltDegrees.peek(),
            FlowerStemSegmentGrowthDurationVarianceHours: this.flowerStemSegmentGrowthDurationVarianceHours.peek(),
            BudBloomDurationVarianceHours: this.budBloomDurationVarianceHours.peek(),
            MaximumFlowersPerCrown: this.maximumFlowersPerCrown.peek(),
            WoodElasticModulus: this.woodElasticModulus.peek(),
            GreenElasticModulus: this.greenElasticModulus.peek(),
            BasalGreenElasticModulus: this.basalGreenElasticModulus.peek(),
            BasalStiffnessAttenuationPerSegment: this.basalStiffnessAttenuationPerSegment.peek(),
            PetioleElasticModulus: this.petioleElasticModulus.peek(),
            FlowerOrganElasticModulus: this.flowerOrganElasticModulus.peek(),
            FlowerPedicelElasticModulus: this.flowerPedicelElasticModulus.peek(),
            FlowerScapeElasticModulus: this.flowerScapeElasticModulus.peek(),
            LeafMaximumAgeHours: this.leafMaximumAgeHours.peek(),
            CrownBudActivationPeriod: this.crownBudActivationPeriod.peek(),
            CrownBudActivationProbabilityPerSeason: this.crownBudActivationProbabilityPerSeason.peek(),
            CrownBudBreakWindowHours: this.crownBudBreakWindowHours.peek(),
            CrownBudRadius: this.crownBudRadius.peek(),
            CrownNodeHeightAboveSoil: this.crownNodeHeightAboveSoil.peek(),
            MinimumInternodeLength: this.minimumInternodeLength.peek(),
            CrownPitch: this.crownPitchDeg.peek() * DegToRad,
            CrownMaximumNodes: this.crownMaximumNodes.peek(),
            HerbaceousGrowthRateScale: this.herbaceousGrowthRateScale.peek(),
            ShootMaximumRadius: this.shootMaximumRadius.peek(),
            PetioleReorientationMaximumAngle: this.petioleReorientationMaximumAngleDeg.peek() * DegToRad,
            PetioleReorientationStepAngle: this.petioleReorientationStepAngleDeg.peek() * DegToRad,
            PetioleSegmentLength: this.petioleSegmentLength.peek(),
            MaximumPetioleSegments: this.maximumPetioleSegments.peek(),
            RhizomeGrowthRateScale: this.rhizomeGrowthRateScale.peek(),
            RhizomeBudActivationPeriod: this.rhizomeBudActivationPeriod.peek(),
            RhizomeBasalBudActivationProbabilityPerHour: this.rhizomeBasalBudActivationProbabilityPerHour.peek(),
            RhizomeAxillaryBudActivationProbabilityPerHour: this.rhizomeAxillaryBudActivationProbabilityPerHour.peek(),
            RhizomeAxillaryBudActivationProbabilityPerSeason: this.rhizomeAxillaryBudActivationProbabilityPerSeason.peek(),
            RhizomeBudBreakWindowHours: this.rhizomeBudBreakWindowHours.peek(),
            RhizomeObstacleDeflectionAngle: this.rhizomeObstacleDeflectionAngleDeg.peek() * DegToRad,
            RhizomeAxillaryBudsPerSegment: this.rhizomeAxillaryBudsPerSegment.peek(),
            InitialBasalRhizomeBuds: this.initialBasalRhizomeBuds.peek(),
            RhizomeMaximumSegmentDepth: this.rhizomeMaximumSegmentDepth.peek(),
            RhizomeSegmentLength: this.rhizomeSegmentLength.peek(),
            RhizomeSegmentLengthVar: this.rhizomeSegmentLengthVar.peek(),
            RhizomeSegmentRadius: this.rhizomeSegmentRadius.peek(),
            RhizomeBudRadius: this.rhizomeBudRadius.peek(),
            RetainDormantRhizomes: this.retainDormantRhizomes.peek(),
            DroughtSenescenceOnset: this.droughtSenescenceOnset.peek(),
            CanopyAdjustmentHalfTimeDays: this.canopyAdjustmentHalfTimeDays.peek(),
            DeadLeafAttachmentHours: this.deadLeafAttachmentHours.peek(),
        };
    }
}
